// extracted by mini-css-extract-plugin
export default {"appealService":"LkmAppealDetailService_appealService__eGBIp","appealService__rating":"LkmAppealDetailService_appealService__rating__qNnUe"};